import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Popups = _resolveComponent("Popups")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_loader_content = _resolveComponent("loader-content")!

  return (_openBlock(), _createBlock(_component_loader_content, {
    ref: (el) => {_ctx.loader = el}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Header, {
        class: _normalizeClass([_ctx.route.meta.containerClass])
      }, null, 8, ["class"]),
      _createElementVNode("div", {
        id: "content",
        class: _normalizeClass(["container", [_ctx.route.meta.containerClass]])
      }, [
        _createVNode(_component_router_view),
        _createVNode(_component_Menu)
      ], 2),
      _createVNode(_component_Popups, {
        ref: (el) => _ctx.popups = el
      }, null, 512),
      _createVNode(_component_notifications, {
        class: _normalizeClass([_ctx.route.meta.containerClass]),
        position: "bottom center"
      }, null, 8, ["class"])
    ]),
    _: 1
  }, 512))
}